import React from 'react';
import { Button } from '@gafe/common-ui';
import merge from 'classnames';

import { Props } from './types';

import styles from './ConfirmationBanner.module.scss';

export const ConfirmationBanner = ({
  onSubmitButtonClick,
  onCancelButtonClick,
  title,
  subTitle,
  submitTitle,
  cancelTitle,
  classes,
}: Props) => {
  return (
    <div className={merge(styles.wrapper, classes?.wrapper)}>
      <div className={styles.container}>
        <div className={merge(styles.title, classes?.title)}>{title}</div>
        <div className={styles.sub_title}>{subTitle}</div>
        <div className={styles.action_buttons}>
          <Button
            colorSchema="destructive"
            gutter="md"
            onClick={onSubmitButtonClick}
            variant="contained"
            width="full"
          >
            {submitTitle}
          </Button>
          <span className={styles.cancel_button} onClick={onCancelButtonClick}>
            {cancelTitle}
          </span>
        </div>
      </div>
    </div>
  );
};
